import bootstrap from '../image/icons/bootstrap.png';
import datastructure from '../image/icons/datastructure.png';
import express from '../image/icons/express.png';
import functional from '../image/icons/functional.png';
import Mongodb from '../image/icons/mongodb.png';
import nest from '../image/icons/nest.png';
import next from '../image/icons/next.png';
import postgress from '../image/icons/postgress.png';
import prisma from '../image/icons/prisma.png';
import problemsolving from '../image/icons/problemsolving.png';
import redux from '../image/icons/redux.png';
import tailwind from '../image/icons/tailwind.png';
import ts from '../image/icons/ts.png';
import bootstrap_black from '../image/icons/bootstrap_black.png';
import db_black from '../image/icons/db_black.png';
import express_black from '../image/icons/express_black.png';
import function_black from '../image/icons/function_black.png';
import mongodb_black from '../image/icons/mongodb_black.png';
import nest_black from '../image/icons/nest_black.png';
import next_black from '../image/icons/next_black.png';
import postgress_black from '../image/icons/postgress_black.png';
import prisma_black from '../image/icons/prisma_black.png';
import problem_black from '../image/icons/problem_black.png';
import redux_black from '../image/icons/redux_black.png';
import tailwind_black from '../image/icons/tailwind_black.png';
import ts_black from '../image/icons/ts_black.png';


export const coreExpertise = [
    {
        id: 1,
        name: 'JavaScript (ES6+)',
        description: 'Advanced asynchronous programming, Event Loop, Closures, Prototypes, Promises, ES Modules, and high-performance DOM & engine optimizations.',
        icon: 'fab fa-js'
    },
    {
        id: 2,
        name: 'TypeScript',
        description: 'Strong static typing, Generics, mapped types, utility types, robust interfaces, and strict type safety across full-stack applications.',
        image: ts,
        black_img: ts_black,
        icon: 'fa-solid fa-code'
    },
    {
        id: 3,
        name: 'React.js',
        description: 'Component architecture, custom hooks, context, state optimization, code-splitting, lazy loading, and micro-interactions.',
        icon: 'fab fa-react'
    },
    {
        id: 4,
        name: 'Next.js',
        description: 'Server-Side Rendering (SSR), Static Site Generation (SSG), App Router, dynamic routing, API routes, and SEO optimization.',
        image: next,
        black_img: next_black,
        icon: 'fa-solid fa-atom'
    },
    {
        id: 5,
        name: 'Express.js & Node.js',
        description: 'RESTful API design, middleware pipelines, authentication (JWT), error handling, socket connections, and microservice integration.',
        image: express,
        black_img: express_black,
        icon: 'fab fa-node-js'
    },
    {
        id: 6,
        name: 'MySQL',
        description: 'Relational schema design, normalization, query optimization, indexing strategies, complex joins, and transaction management.',
        icon: 'fas fa-database'
    }
];

export const workingKnowledge = [
    {
        id: 7,
        name: 'PostgreSQL',
        description: 'Relational data modeling, indexing, foreign keys, and performant querying.',
        image: postgress,
        black_img: postgress_black,
        icon: 'fa-solid fa-database'
    },
    {
        id: 8,
        name: 'MongoDB & Mongoose',
        description: 'Document database schema modeling, aggregations, indexing, and CRUD operations.',
        image: Mongodb,
        black_img: mongodb_black,
        icon: 'fa-solid fa-database'
    },
    {
        id: 9,
        name: 'Nest.js',
        description: 'Enterprise modular backend architecture, dependency injection, and decorators.',
        image: nest,
        black_img: nest_black,
        icon: 'fa-solid fa-feather'
    },
    {
        id: 10,
        name: 'Prisma ORM',
        description: 'Type-safe database client, migrations, relation queries, and schema generation.',
        image: prisma,
        black_img: prisma_black,
        icon: 'fa-solid fa-shield-alt'
    },
    {
        id: 11,
        name: 'Hono.js',
        description: 'Ultrafast, lightweight web framework for edge and modern JavaScript runtimes.',
        icon: 'fas fa-fire'
    },
    {
        id: 12,
        name: 'Redux Toolkit & RTK Query',
        description: 'Centralized state management, slice reducers, caching, and optimistic UI updates.',
        image: redux,
        black_img: redux_black,
        icon: 'fa-solid fa-atom'
    },
    {
        id: 13,
        name: 'Tailwind CSS',
        description: 'Utility-first responsive layouts, modern design tokens, and clean UI components.',
        image: tailwind,
        black_img: tailwind_black,
        icon: 'fa-brands fa-css3'
    },
    {
        id: 14,
        name: 'Bootstrap & SCSS',
        description: 'Responsive grid systems, custom Sass variables, mixins, and neumorphic styling.',
        image: bootstrap,
        black_img: bootstrap_black,
        icon: 'fa-brands fa-bootstrap'
    },
    {
        id: 15,
        name: 'Data Structures & Algorithms',
        description: 'Arrays, Trees, Hash Tables, Graphs, Sorting, Searching, and Big-O efficiency analysis.',
        image: datastructure,
        black_img: db_black,
        icon: 'fa-solid fa-folder-tree'
    },
    {
        id: 16,
        name: 'Problem Solving',
        description: 'Analytical problem decomposition, edge case handling, and algorithm optimization.',
        image: problemsolving,
        black_img: problem_black,
        icon: 'fa-solid fa-puzzle-piece'
    },
    {
        id: 17,
        name: 'Functional Programming & OOP',
        description: 'Immutability, pure functions, composition, design patterns, encapsulation, and polymorphism.',
        image: functional,
        black_img: function_black,
        icon: 'fa-solid fa-cogs'
    },
    {
        id: 18,
        name: 'ERD & Database Architecture',
        description: 'Entity Relationship Diagrams, cardinality, schema design, and data integrity constraints.',
        icon: 'fa-solid fa-project-diagram'
    }
];

export const cloudInfra = [
    {
        id: 19,
        name: 'AWS Cloud Services',
        description: 'Lambda (Serverless), EventBridge, S3 Storage, RDS, EC2 Instances, and AppSync GraphQL.',
        icon: 'fab fa-aws'
    },
    {
        id: 20,
        name: 'DigitalOcean Cloud',
        description: 'Droplets deployment, Storage Spaces/Buckets, Managed Redis, and Managed MySQL clusters.',
        icon: 'fab fa-digital-ocean'
    },
    {
        id: 21,
        name: 'Redis Caching',
        description: 'In-memory data store for caching, session management, rate limiting, and 70%+ latency reduction.',
        icon: 'fas fa-bolt'
    },
    {
        id: 22,
        name: 'Payment Gateways',
        description: 'bKash recurring subscriptions, Stripe checkout & webhooks, Robi, GP, and secure reconciliation.',
        icon: 'fas fa-credit-card'
    }
];

export const devTools = [
    {
        id: 23,
        name: 'Docker',
        description: 'Containerization, Dockerfile configuration, multi-container setups, and consistent dev/prod environments.',
        icon: 'fab fa-docker'
    },
    {
        id: 24,
        name: 'Git & GitHub',
        description: 'Version control, branch workflows, pull request reviews, merge resolution, and Git actions.',
        icon: 'fab fa-github'
    },
    {
        id: 25,
        name: 'Cursor Agent with Graphify',
        description: 'AI-assisted code navigation, persistent codebase knowledge graphs, and rapid full-stack development.',
        icon: 'fas fa-brain'
    },
    {
        id: 26,
        name: 'Claude & Modern AI Tools',
        description: 'Leveraging frontier LLMs for pair programming, architectural design, debugging, and code refactoring.',
        icon: 'fas fa-robot'
    }
];